import directObj from './directiveConf';

export default {
  inserted(el, binding, vnode) {
    const domDragContainer = el.firstElementChild.firstElementChild;
    directObj.bind(domDragContainer);
    directObj.update(domDragContainer, binding);
  }
};
